import React, { useEffect, useContext, useState } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
} from "./../../components/card/card.jsx";
import { AppSettings } from "./../../config/app-settings.js";
import { useAuth } from "../../contexts/AuthContext";
import { toast } from "react-toastify";
import { useParams, useNavigate } from "react-router-dom";
import LoadingIndicator from "../../components/LoadingIndicator";
import ConfirmationDlg from "../../components/ConfirmationDlg";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { auth, workOrderCategory, location, asset, workOrder } from "../../api";
import "react-phone-number-input/style.css";
import "@sweetalert2/theme-dark/dark.css";
import PhoneInput from "react-phone-number-input";
import Swal from "sweetalert2";
import { getEmptyField, isValidEmail } from "../../utils/helper.jsx";
import NormalInput from "../../components/form/HorizontalNormalInput";
import NormalSelect from "../../components/form/HorizontalNormalSelect";
import MultipleFilesAttachments from "../../components/MultipleFilesAttachments";
import LocationSelectChain from "../../components/LocationFilterClient";

function PublicRegister() {
  const { token } = useParams();
  const navigate = useNavigate();
  const { login } = useAuth();
  const [attachments, setAttachments] = useState([]);
  const context = useContext(AppSettings);
  const [inputs, setInputs] = useState({
    asset_id: "",
    email: "",
    whatsapp: "",
    start_date: "",
    due_date: "",
    status: "",
    asset_component_id: "",
    description: "",
    title: "",
    recurring_wo: "",
    priority: "medium",
    assigned_to: "",
    fault: "",
    team_id: "",
    vendor_id: "",
    category_id: "",
    tasks: [],
    inventories: [],
    is_request: true,
  });
  const [termModal, setTermModal] = useState(false);

  const [phone, setPhone] = useState("");
  const downloadIcon =
    "data:image/svg+xml;base64,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";
  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputs({ ...inputs, [name]: value });
  };

  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [modalError, setModalError] = React.useState(false);
  const [categories, setCategories] = useState([]);
  const [locations, setLocations] = useState([]);
  const [locationWording, setLocationWording] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [isDataLoaded, setIsDataLoaded] = React.useState(true);
  const [sublocation, setSublocation] = useState("");
  const [url, setUrl] = useState("");
  const [emptyField, setEmptyField] = useState([]);
  const [subLocations, setSubLocations] = useState([]);
  const [assets, setAssets] = useState([]);
  const [error, setError] = useState(null);
  //forgot
  const fetchData = async () => {
    console.log("start fetch");
    try {
      setLoading(true);
      const getCategory = await workOrderCategory.listByToken({ token });
      if (getCategory.ok) {
        const body = await getCategory.json();
        let data = body.data;
        if (data && Array.isArray(data)) {
          data.map((d) => {
            d["name"] = d.name;
            d["value"] = d.id;
          });
          setCategories(data);
        } else {
          if (!data?.success) {
            setIsDataLoaded(false)
          }
        }
      }
      const getLocation = await location.listByToken(token);
      if (getLocation.ok) {
        const body = await getLocation.json();
        if (body.data && Array.isArray(body.data)) {
          const tmp = body.data?.filter(i=>!i.parent_location_id)
            if(tmp.length){
                setLocationWording(tmp[0].company?.location_wording?.split(','));
            }
            console.log({tmp})
          setLocations(tmp);
        } else {
          if (!body?.success) {
            setIsDataLoaded(false)
          }
        }
      }
    } catch (e) {
      console.error(`[fetchData] error: ${e}`)
      setIsDataLoaded(false);
      setLoading(false);
      setError(e?.message ?? "Unknown error");
    } finally {
      setLoading(false);
    }
  };

  const fetchAsset = async () => {
    const getAsset = await asset.listByToken({
      location_id: selectedLocation,
      token,
    });
    if (getAsset.ok) {
      const body = await getAsset.json();
      let data = body.data;
      if (data) {
        data.map((d) => {
          d["name"] = d.name;
          d["value"] = d.id;
        });
        setAssets(data);
      }
    }
  };
    useEffect(() => {
        fetchAsset()
    }, [selectedLocation]);
    const handleDeepestLocationChange = (id) => {
        setInputs({ ...inputs, asset_id: "" });
        console.log({id})
        setSelectedLocation(id)
    };

  useEffect(() => {
    if (sublocation) {
      fetchAsset();
    }
  }, [sublocation]);

  useEffect(() => {}, []);

  useEffect(() => {
    context.setAppHeaderNone(true);
    context.setAppSidebarNone(true);
    context.setAppContentClass("p-0");
    fetchData();
    return function cleanUp() {
      context.setAppHeaderNone(false);
      context.setAppSidebarNone(false);
      context.setAppContentNone(false);
      context.setAppContentClass("");
    };

    // eslint-disable-next-line
  }, []);
  const tooltip = (word) => (
    <Tooltip id="tooltip">
      <strong>{word}</strong>
    </Tooltip>
  );
  const [agree, setAgree] = useState(false);

  const onAgree = () => {
    setTermModal(false);
    setAgree(true);
  };

  const onGoLogin = () => {
    window.location.href = "https://app.groundup.ai";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      let payload = { ...inputs };
      payload.location_id = selectedLocation;
      if(!payload.location_id ){
          toast.error(
               "Please fill all mandatory field"
          );
          return
      }

      let res;
      res = await workOrder.createByToken(token, payload, attachments);

      if (res.ok) {
        toast.success(`Your request has been submitted successfully`);
        setSubmitted(true)
          const body = await res.json();
          let data = body.data;
          setUrl(data.url)
      } else {
        const errorBody = await res.json();
        toast.error(
          errorBody.message || "Something went wrong, please try again"
        );
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login" style={{ background: "#061929" }}>
      <LoadingIndicator open={loading} />
      {!loading && isDataLoaded && <div style={{ width: "100%", padding: "0 50px" }}>
        {!submitted ? (
          <form onSubmit={handleSubmit}>
            <div className="my-1 text-center">
              <h2>Request Form</h2>
            </div>
            <div className="row justify-content-center">
              <div className="col-md-6 col-12" style={{ padding: "30px" }}>
                <div>
                  <OverlayTrigger
                    placement="top"
                    overlay={tooltip("Your email address")}
                  >
                    <label className="form-label" style={{ minHeight: "15px" }}>
                      Email <span className="text-danger">*</span>
                    </label>
                  </OverlayTrigger>
                  <input
                    type="text"
                    name="email"
                    value={inputs.email}
                    onChange={handleChange}
                    required={true}
                    style={{
                      color: "gold",
                      background: "rgb(4 13 22) !important",
                    }}
                    className="form-control form-control-lg bg-white bg-opacity-5"
                    placeholder="Enter Your Email"
                  />
                </div>
                <div style={{marginTop:"20px"}}>
                  <OverlayTrigger
                    placement="top"
                    overlay={tooltip("Your Phone Number")}
                  >
                    <label className="form-label" style={{ minHeight: "15px" }}>
                      Whatsapp (for notification)
                    </label>
                  </OverlayTrigger>
                    <div className="phone-request" >
                        <PhoneInput
                            international={true}
                            defaultCountry="SG"
                            value={inputs.whatsapp}
                            onChange={(value) =>
                                setInputs({ ...inputs, whatsapp: value })
                            }
                        />
                        <small>* For Alert Notification</small>
                    </div>
                </div>
                <div className={"mt-2"}>
                  <OverlayTrigger
                    placement="top"
                    overlay={tooltip("Request title")}
                  >
                    <label className="form-label" style={{ minHeight: "15px" }}>
                      Request Title <span className="text-danger">*</span>
                    </label>
                  </OverlayTrigger>
                  <input
                    type="text"
                    name="title"
                    value={inputs.title}
                    onChange={handleChange}
                    required={true}
                    style={{
                      backgroundColor: "rgb(4 13 22) !important",
                    }}
                    className="form-control form-control-lg bg-white bg-opacity-5"
                    placeholder="Enter Your Request Title"
                  />
                </div>
                <div className={"mt-2"}>
                  <label className="form-label" style={{ minHeight: "15px" }}>
                    Category <span className="text-danger">*</span>
                  </label>
                  <select
                    name="category_id"
                    value={inputs.category_id}
                    onChange={handleChange}
                    className="form-control form-control-lg bg-white bg-opacity-5"
                  >
                    <option value="">- Select -</option>
                    {categories.map((category) => (
                      <option key={category.id} value={category.id}>
                        {category.name}
                      </option>
                    ))}
                  </select>
                </div>
                  <LocationSelectChain roots={locations} locationWord={locationWording} onDeepestChange={handleDeepestLocationChange}></LocationSelectChain>
                <div className={"mt-2"}>
                  <label className="form-label" style={{ minHeight: "15px" }}>
                    Asset
                  </label>
                  <select
                    value={inputs.asset_id}
                    name="asset_id"
                    onChange={handleChange}
                    className="form-control form-control-lg bg-white bg-opacity-5"
                  >
                    <option value="">- Select -</option>
                    {assets.map((asset) => (
                      <option key={asset.id} value={asset.id}>
                        {asset.asset_name}
                      </option>
                    ))}
                  </select>
                </div>

                <div style={{ marginTop: "15px" }}>
                  <OverlayTrigger
                    placement="top"
                    overlay={tooltip("Description")}
                  >
                    <label className="form-label" style={{ minHeight: "15px" }}>
                      Description <span className="text-danger">*</span>
                    </label>
                  </OverlayTrigger>
                  <input
                    type="text"
                    name="description"
                    value={inputs.description}
                    onChange={handleChange}
                    required={true}
                    className="form-control form-control-lg bg-white bg-opacity-5"
                    placeholder="Description"
                  />
                </div>
                <Card style={{ marginTop: "10px" }}>
                  <CardHeader>Attachments</CardHeader>
                  <CardBody>
                    <MultipleFilesAttachments
                      attachments={attachments}
                      setAttachments={setAttachments}
                    ></MultipleFilesAttachments>
                  </CardBody>
                </Card>
                <div style={{ textAlign: "center" }}>
                  <button
                    type="submit"
                    disabled={loading}
                    className="iframe-button"
                  >
                    Submit Request
                  </button>
                </div>
              </div>
            </div>
            <ConfirmationDlg
              title="Warning"
              open={modalError}
              onClose={() => setModalError(false)}
              btnSubmitText={"Login CMMS"}
              onSubmit={onGoLogin}
              btnCancelText={"Cancel"}
            >
              <h4>Your Email is already registered, Please Login</h4>
            </ConfirmationDlg>
            <ConfirmationDlg
              size={"lg"}
              open={termModal}
              onClose={() => setTermModal(false)}
              title="Terms of Use"
              btnCancelText={"Close"}
              btnSubmitText={"Agree"}
              onSubmit={onAgree}
            ></ConfirmationDlg>
          </form>
        ) : (
          <div className="row justify-content-center">
            <div className="col-12 col-md-6">
              <Card className="mb-4">
                <CardHeader className="d-flex align-items-center bg-inverse bg-opacity-10 fw-400">
                  Your request submitted Successfully
                </CardHeader>
                <CardBody>
                  <div>
                    <p style={{ fontSize: "16px" }}>
                      Thank you for submitting your request. Our team will
                      review it and get back to you shortly.
                    </p>
                    <p style={{ fontSize: "16px" }}>
                      To track the progress detail please use this URL :
                    </p>
                    <p style={{ fontSize: "16px" }}>
                        <a href={url}>{url}</a>
                    </p>
                    <div className="row justify-content-between"></div>
                  </div>
                </CardBody>
              </Card>
            </div>
          </div>
        )}
      </div>}
      {!loading && !isDataLoaded && <div style={{ width: "100%", padding: "0 50px" }}>
          <div className="row justify-content-center">
            <div className="col-12 col-md-6">
              <Card className="mb-4">
                <CardHeader className="d-flex align-items-center bg-inverse bg-opacity-10 fw-400">
                  Error / Broken Link
                </CardHeader>
                <CardBody>
                  <div>
                    <p style={{ fontSize: "16px" }}>
                      {error ? error : "This link is no longer valid. Please use the updated link."}
                    </p>
                    <div className="row justify-content-between"></div>
                  </div>
                </CardBody>
              </Card>
            </div>
          </div>
        </div>}
    </div>
  );
}

export default PublicRegister;
